import { VeevaVaultDocument } from 'generated/maya.types';

const useIVADocumentIdOptions = (veevaVaultDocument: VeevaVaultDocument[]) => {
  const IVADocumentIdOptions = veevaVaultDocument.map((element: VeevaVaultDocument) => {
    return {
      id: element.id.toString(),
      label: `[${element.documentNumber}] [${element.status}] ${element.name}` as string,
    };
  });

  return IVADocumentIdOptions;
};

export default useIVADocumentIdOptions;
